import RejectedApplications from "../Administration/RejectedApplications";

const NagarrachanaRejectedApplications = ({ role }) => {
  return (
    <>
      <RejectedApplications role={role} />
    </>
  );
};

export default NagarrachanaRejectedApplications;
